import * as React from 'react';

import { Button } from '../components/buttons';
import { IconLinkButton } from '../components/buttons';
import { IconArrowRight } from '../components/icons';
import { DataTable, Table } from '../components/common';
import { TextInput } from '../components/forms';
import Utils, { PaymentStatus } from '../common/utils';
import * as moment from 'moment';

interface Props {
	baseUrl?: string;
	className?: string;
	match: any;
	history: any;
	payments: PaymentHistory[];
	searchterm: string;
	onSearch: (e: any) => void;
}
const PaymentHistoryList = (props: Props) => {

	const sortPaymentHistory = (a: PaymentHistory, b: PaymentHistory) => {
		return  (moment(a.createdDate!).utc()).isAfter(moment(b.createdDate!).utc()) ? -1 : 1;
	};

	const paymentsCopy = [...props.payments];
	const sortedPayments = paymentsCopy.sort(sortPaymentHistory);

	return (
		<div className="content-set">
		<div className="table-options">
				<TextInput
					name="search"
					placeholder="Search"
					value={props.searchterm}
					onChange={props.onSearch}
					className="m-0 table-search"
				/>
		</div>
		<DataTable
			className={props.className}
			TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
			columns={[
				{
					accessor: 'id',
					show: false
				},
				{
					Header: 'Date',
					accessor: 'date',
					Cell: (row: any) => Utils.formatDateAsUTC(row.value)
				},
				{
					Header: 'Invoice #',
					accessor: 'stripeInvoiceNumber'
				},
				{
					Header: 'Amount',
					accessor: 'amount',
					Cell: (row: any) => Utils.formatCurrency(row.value)
				},
				{
					Header: 'Status',
					accessor: 'statusId',
					Cell: (row: any) => Utils.getPickListItemDescription(row.value)
				},
				{
					Header: 'Actions',
					className: 'p-0 td-actions',
					width: 120,
					Cell: (row: any) => {
						if (
							row.original.statusId !== PaymentStatus.PaymentSucceeded &&
							row.original.statusId !== PaymentStatus.Created
						) {
							return (
								<Button
									className="btn-primary btn-td"
									type="button"
									to={
										props.baseUrl
											? `${props.baseUrl}/${row.original.stripeInvoiceNumber}`
											: `/user/${props.match.params.userId}/billing/view-bills/${row.original.stripeInvoiceNumber}`
									}
								>
									Pay Bill
								</Button>
							);
						} else {
							return (
								<IconLinkButton
									title="View bill"
									className="btn-icon-secondary btn-icon-td"
									to={
										props.baseUrl
											? `${props.baseUrl}/${row.original.stripeInvoiceNumber}`
											: `/user/${props.match.params.userId}/billing/view-bills/${row.original.stripeInvoiceNumber}`
									}
								>
									<IconArrowRight />
								</IconLinkButton>
							);
						}
					}
				}
			]}
			getTrProps={(state: any, rowInfo: any, column: any) => {
				return {
					className: 'tr interactive',
					onClick: () => {
						if (props.baseUrl) {
							return props.history.push(`${props.baseUrl}/${rowInfo.original.stripeInvoiceNumber}`);
						} else {
							return props.history.push(
								`/user/${props.match.params.userId}/billing/view-bills/${rowInfo.original.stripeInvoiceNumber}`
							);
						}
					}
				};
			}}
			data={sortedPayments}
			noDataText="You currently have no bills"
		/>
		</div>
	);
};
export default PaymentHistoryList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/payment/PaymentHistoryList.tsx